import { render } from "./AddProduit.vue?vue&type=template&id=bee9ce8a&scoped=true&ts=true"
import script from "./AddProduit.vue?vue&type=script&lang=ts"
export * from "./AddProduit.vue?vue&type=script&lang=ts"

import "./AddProduit.vue?vue&type=style&index=0&id=bee9ce8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bee9ce8a"]])

export default __exports__